<template>
<ValidationObserver class="col" tag="div" ref="form" v-slot="{ handleSubmit, invalid }">
    <Loading />
    <Message />

    <CForm method="post" @submit.prevent="handleSubmit(submit)">
        <CRow>
            <CCustomInput
                col="12"
                vid="name"
                :name="$t('v2commission.group.name')"
                rules="required"
                required
                v-model="group.name"
            />

            <CCustomInput
                col="12"
                vid="sale"
                :name="$t('v2commission.types.sale')"
                rules="required|double_or_numeric"
                required
                ltr
                v-model="group.sale.action_value"
            >
                <template #prepend>
                    <select v-model="group.sale.action_type" class="b-a-1 px-0 px-sm-2" style="border-radius: 0 5px 5px 0;">
                        <option :value="CommissionAmountType.PERCENT">درصدی</option>
                        <option :value="CommissionAmountType.AMOUNT">مقداری</option>
                    </select>
                </template>
                <template #append-content>
                    {{ group.sale.action_type === CommissionAmountType.PERCENT ? $t('percent') : $t('rial') }}
                </template>
            </CCustomInput>

            <CCustomInput
                col="12"
                vid="lead"
                :name="$t('v2commission.types.lead')"
                rules="double_or_numeric"
                ltr
                v-model="group.lead.action_value"
            >
                <template #append-content>
                    {{ $t('rial') }}
                </template>
            </CCustomInput>
        </CRow>

        <CButton :disabled="invalid" type="submit" color="primary" class="px-4 float-right">{{ $t('submit') }}</CButton>
    </CForm>
</ValidationObserver>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { filterObject } from '@/common/objects'
import { CommissionModel, CommissionType, CommissionAmountType } from '@/constants'

export default {
    name: 'GroupForm',

    props: {
        group: {
            default() {
                return {
                    name: '',
                    sale: {
                        action_value: '',
                        action_type: '',
                    },
                    lead: {
                        action_value: '',
                        action_type: '',
                    },
                }
            },
            type: Object
        }
    },

    data() {
        return {
            commission: {},
            CommissionType,
            CommissionAmountType
        }
    },

    computed: {
        ...mapGetters({
            commissions: 'v2commission/commissions'
        }),
        defaults() {
            return filterObject(
                this.commissions,
                commission => commission.model === CommissionModel.DEFAULT && commission.type === CommissionType.MIX
            )
        },
        defaultCommission() {
			const defaultIndex = Object.keys(this.defaults)[0]

			this.commission =  defaultIndex ? this.defaults[defaultIndex] : {}

			return this.commission
		}
    },

    methods: {
        submit() {
            this.$emit('onSubmit', this.group)
        }
    },

    created() {
        if (!this.group.id) {
            this.group.sale.action_value = this.defaultCommission.sale ? this.defaultCommission.sale.action_value : ''
            this.group.sale.action_type = this.defaultCommission.sale ? this.defaultCommission.sale.action_type : CommissionAmountType.PERCENT

            this.group.lead.action_value = this.defaultCommission.lead ? this.defaultCommission.lead.action_value : ''
            this.group.lead.action_type = this.defaultCommission.lead ? this.defaultCommission.lead.action_type : CommissionAmountType.LEAD
        }
    }
}
</script>